import { DeviitorVoiceClient } from './voice-client.js';
import { BUILD_VERSION } from './version.js';

      const statusEl = document.getElementById('status');
      const logEl = document.getElementById('log');
      const chatEl = document.getElementById('chat');
      const chatEmpty = document.getElementById('chatEmpty');
      const chatPanel = document.getElementById('chatPanel');
      const micBtn = document.getElementById('micBtn');
      const stopBtn = document.getElementById('stopBtn');
      const muteBtn = document.getElementById('muteBtn');
      const fabActions = document.getElementById('fabActions');
      const debugFab = document.getElementById('debugFab');
      const debugPanel = document.getElementById('debugPanel');
      const debugClose = document.getElementById('debugClose');
      const micModal = document.getElementById('micModal');
      const micModalBody = document.getElementById('micModalBody');
      const micModalRetry = document.getElementById('micModalRetry');
      const micModalDismiss = document.getElementById('micModalDismiss');

      let sessionMeta = null;
      let client = null;
      let expiryTimer = null;
      let connectedUi = false;

      function showMicPermissionModal(message) {
        micModalBody.textContent =
          message ||
          'Allow microphone access to start the voice session. If you blocked it earlier, enable the mic for this site in your browser settings.';
        micModal.hidden = false;
        micModal.classList.add('visible');
      }

      function hideMicPermissionModal() {
        micModal.classList.remove('visible');
        micModal.hidden = true;
      }

      function releaseMicStream(stream) {
        try {
          stream?.getTracks?.().forEach((t) => t.stop());
        } catch {}
      }

      function log(line) {
        const stamp = new Date().toLocaleTimeString();
        logEl.textContent = `[${stamp}] ${line}\n` + logEl.textContent;
        console.log(line);
      }

      function setStatus(text) {
        statusEl.textContent = text;
      }

      function setMuteUi(muted) {
        muteBtn.classList.toggle('muted', muted);
        muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');
        muteBtn.textContent = muted ? 'Unmute' : 'Mute';
        micBtn.classList.toggle('muted-mic', muted && connectedUi);
        micBtn.title = muted ? 'Microphone muted' : connectedUi ? 'Connected' : 'Start talking';
      }

      function setConnectedUi(on) {
        connectedUi = on;
        micBtn.classList.toggle('connected', on);
        fabActions.classList.toggle('visible', on);
        chatPanel.classList.toggle('visible', on);
        debugFab.classList.toggle('visible', on);
        if (!on) {
          debugPanel.classList.remove('visible');
          debugFab.classList.remove('open');
          setMuteUi(false);
        }
      }

      function escapeHtml(text) {
        return String(text)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      /** Turn spoken clock words into digit times for readable transcripts */
      function normalizeSpokenTimes(text) {
        const hours = {
          twelve: 12,
          eleven: 11,
          ten: 10,
          nine: 9,
          eight: 8,
          seven: 7,
          six: 6,
          five: 5,
          four: 4,
          three: 3,
          two: 2,
          one: 1,
        };
        let out = String(text);
        out = out.replace(
          /\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\s+thirty\s*(a\.?\s*m\.?|p\.?\s*m\.?|am|pm)\b/gi,
          (_m, h, mer) => {
            const hour = hours[h.toLowerCase()];
            const ap = /p/i.test(mer) ? 'PM' : 'AM';
            return `${hour}:30 ${ap}`;
          },
        );
        out = out.replace(
          /\b(one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve)\s*(a\.?\s*m\.?|p\.?\s*m\.?|am|pm)\b/gi,
          (_m, h, mer) => {
            const hour = hours[h.toLowerCase()];
            const ap = /p/i.test(mer) ? 'PM' : 'AM';
            return `${hour} ${ap}`;
          },
        );
        return out;
      }

      /** Turn spoken emails into user@domain.tld when possible */
      function normalizeSpokenEmail(text) {
        let out = String(text);

        // "alex at yogmail dot com" / "a l e x at yop mail dot com"
        out = out.replace(
          /\b([a-z0-9][a-z0-9.\s_%+-]*?)\s+at\s+([a-z0-9][a-z0-9.\s-]*?)\s+dot\s+([a-z]{2,})\b/gi,
          (_m, user, domain, tld) =>
            `${String(user).replace(/\s+/g, '')}@${String(domain).replace(/\s+/g, '')}.${tld}`,
        );

        // "alex at yogmail.com" (domain already dotted)
        out = out.replace(
          /\b([a-z0-9][a-z0-9.\s_%+-]*?)\s+at\s+([a-z0-9][a-z0-9.-]*\.[a-z]{2,})\b/gi,
          (_m, user, domain) => `${String(user).replace(/\s+/g, '')}@${domain}`,
        );

        // "name dot last at domain dot com"
        out = out.replace(
          /\b([a-z0-9]+(?:\s+dot\s+[a-z0-9]+)+)\s+at\s+([a-z0-9][a-z0-9.\s-]*?)\s+dot\s+([a-z]{2,})\b/gi,
          (_m, user, domain, tld) =>
            `${String(user).replace(/\s+dot\s+/gi, '.').replace(/\s+/g, '')}@${String(domain).replace(/\s+/g, '')}.${tld}`,
        );

        return out;
      }

      function normalizeEmailFieldValue(value) {
        let email = normalizeSpokenEmail(String(value || '').trim());
        email = email.replace(/\s+/g, ' ').trim();

        // Already a normal email
        if (/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email)) return email;

        // "alex yogmail.com" → alex@yogmail.com
        const spacedDomain = email.match(
          /^([a-z0-9._%+-]+)\s+([a-z0-9][a-z0-9.-]*\.[a-z]{2,})$/i,
        );
        if (spacedDomain) return `${spacedDomain[1]}@${spacedDomain[2]}`;

        // Only invent an @ when there is a single spoken "dot" (user domain dot tld).
        // Phrases like "l x dot mail dot com" stay as-is rather than becoming garbage.
        const dotCount = (email.match(/\bdot\b/gi) || []).length;
        if (dotCount === 1) {
          const loose = email.match(
            /^([a-z0-9][a-z0-9\s._%+-]*?)\s+([a-z0-9][a-z0-9\s-]*?)\s+dot\s+([a-z]{2,})$/i,
          );
          if (loose) {
            return `${loose[1].replace(/\s+/g, '')}@${loose[2].replace(/\s+/g, '')}.${loose[3]}`;
          }
        }

        return email;
      }

      /** Promote bare domains / paths to https URLs for display */
      function normalizeBareUrls(text) {
        return String(text).replace(
          /(^|[\s("'])((?:https?:\/\/)?(?:(?:[\w-]+\.)+[a-z]{2,})(?:\/[\w?=&%./~+-]*)?)/gi,
          (_m, prefix, url) => {
            // Skip emails already handled elsewhere / incomplete tokens
            if (url.includes('@')) return `${prefix}${url}`;
            const full = /^https?:\/\//i.test(url) ? url : `https://${url}`;
            return `${prefix}${full}`;
          },
        );
      }

      function linkifyHtml(escapedText) {
        let html = escapedText;
        html = html.replace(
          /\b[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}\b/gi,
          (email) =>
            `<a href="mailto:${email}" target="_blank" rel="noopener noreferrer">${email}</a>`,
        );
        html = html.replace(/https?:\/\/[^\s<>"')\]]+/gi, (url) => {
          const clean = url.replace(/[.,;:!?)]+$/, '');
          const trail = url.slice(clean.length);
          let label = clean.replace(/^https?:\/\//i, '');
          if (label.length > 56) label = `${label.slice(0, 53)}…`;
          return `<a href="${clean}" target="_blank" rel="noopener noreferrer">${label}</a>${trail}`;
        });
        return html;
      }

      const FALLBACK_BOOKING_URL = 'https://calendar.app.google/983Vkg8WixeY8yWf6';
      const PORTFOLIO_URL = 'https://dilhara.deviitor.com';
      const PORTFOLIO_WORK_URL = 'https://dilhara.deviitor.com/work';
      const PROJECT_LINKS = [
        {
          keys: [/flood/i, /early.?warning/i, /river/i],
          label: 'Flood Early Warning case study',
          url: 'https://dilhara.deviitor.com/work/flood-early-warning',
        },
        {
          keys: [/grands.?m[eè]res/i, /grands-meres/i, /natural.?remed/i],
          label: 'Grands-Meres case study',
          url: 'https://dilhara.deviitor.com/work/grands-meres',
        },
        {
          keys: [/wrestling/i, /wrestlingworld/i],
          label: 'WrestlingWorld case study',
          url: 'https://dilhara.deviitor.com/work/wrestlingworld',
          live: { label: 'Live site', url: 'https://wrestlingworld.co' },
        },
        {
          keys: [/better.?move/i, /kuwaiti.?mov/i],
          label: 'Better Move case study',
          url: 'https://dilhara.deviitor.com/work/better-move',
          live: { label: 'Live site', url: 'https://bettermoveco.com' },
        },
      ];
      const shownLinkKeys = new Set();
      /** Last single project mentioned in this call (agent or user). */
      let lastMentionedProjectUrl = null;
      /** Successful create_booking payload — reshare Meet/event only, never public page. */
      let lastBookingResult = null;

      function addLinksCard({ title, links, key, force = false }) {
        const usable = (links || []).filter((l) => l?.url);
        if (!usable.length) return false;
        const cardKey = key || usable.map((l) => l.url).join('|');
        if (!force && shownLinkKeys.has(cardKey)) {
          // Already shown earlier this session — still counts as present in chat.
          return true;
        }
        shownLinkKeys.add(cardKey);

        const empty = document.getElementById('chatEmpty');
        if (empty) empty.remove();
        const el = document.createElement('div');
        el.className = 'bubble agent summary';
        el.dataset.linksCard = cardKey;
        const items = usable
          .map(
            (l) =>
              `<a href="${escapeHtml(l.url)}" target="_blank" rel="noopener noreferrer">` +
              `<span class="link-label">${escapeHtml(l.label)}</span>` +
              `${escapeHtml(String(l.url).replace(/^https?:\/\//i, ''))}</a>`,
          )
          .join('');
        el.innerHTML =
          `<span class="who">Links</span>` +
          `<div class="summary-title">${escapeHtml(title || 'Useful links')}</div>` +
          `<div class="link-card">${items}</div>`;
        chatEl.appendChild(el);
        chatEl.scrollTop = chatEl.scrollHeight;
        return true;
      }

      function bookingLinksPresentInChat(meetLink, htmlLink) {
        const hrefs = [...chatEl.querySelectorAll('.link-card a')]
          .map((a) => a.getAttribute('href') || '')
          .filter(Boolean);
        const hasMeet = meetLink
          ? hrefs.some((h) => h === meetLink || /meet\.google\.com/i.test(h))
          : false;
        const hasCal = htmlLink
          ? hrefs.some(
              (h) => h === htmlLink || /calendar\.google\.com|google\.com\/calendar/i.test(h),
            )
          : false;
        return Boolean(hasMeet && hasCal);
      }

      function removeBookingLinkCards() {
        chatEl.querySelectorAll('.bubble[data-links-card]').forEach((el) => {
          const key = el.getAttribute('data-links-card') || '';
          if (key.startsWith('booking-') || key === 'fallback-booking') el.remove();
        });
        for (const key of [...shownLinkKeys]) {
          if (String(key).startsWith('booking-') || key === 'fallback-booking') {
            shownLinkKeys.delete(key);
          }
        }
      }

      function addFallbackBookingCard(force = false) {
        if (lastBookingResult?.ok) return false;
        return addLinksCard({
          key: 'fallback-booking',
          title: 'Booking',
          links: [{ label: 'Book a call', url: FALLBACK_BOOKING_URL }],
          force,
        });
      }

      async function callFunctionApi(name, args) {
        const res = await fetch(`/api/functions/${name}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: sessionMeta.sessionAuth,
            'X-Session-Id': sessionMeta.sessionId,
          },
          body: JSON.stringify(args),
        });
        return res.json();
      }

      async function settleChatDom() {
        await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
        await new Promise((r) => setTimeout(r, 80));
      }

      async function ensureBookingLinksInChat(result) {
        let current = { ...result, links_ready: false, links_in_chat: false };
        lastBookingResult = current;
        const maxAttempts = 5;

        for (let attempt = 0; attempt < maxAttempts; attempt++) {
          if (attempt > 0 && current.eventId) {
            log(`Refreshing booking links (attempt ${attempt + 1})…`);
            try {
              const refreshed = await callFunctionApi('refresh_booking_links', {
                event_id: current.eventId,
              });
              if (refreshed?.ok) {
                current = {
                  ...current,
                  meetLink: refreshed.meetLink || current.meetLink,
                  htmlLink: refreshed.htmlLink || current.htmlLink,
                };
              }
            } catch (err) {
              log(`refresh_booking_links failed: ${err?.message || 'error'}`);
            }
          }

          const links = [];
          if (current.meetLink) links.push({ label: 'Google Meet', url: current.meetLink });
          if (current.htmlLink) links.push({ label: 'Calendar event', url: current.htmlLink });

          if (links.length) {
            removeBookingLinkCards();
            addLinksCard({
              key: `booking-${current.eventId || current.meetLink || 'links'}`,
              title: 'Your booking links',
              links,
              force: true,
            });
          }

          await settleChatDom();
          if (bookingLinksPresentInChat(current.meetLink, current.htmlLink)) {
            current.links_available = true;
            current.links_ready = true;
            current.links_in_chat = true;
            current.agent_speak =
              'You are booked. Google Meet and calendar EVENT links are confirmed in the chat. Say you shared those — never the public calendar.app.google page.';
            lastBookingResult = current;
            return current;
          }

          await new Promise((r) => setTimeout(r, 700));
        }

        current.links_available = Boolean(current.meetLink && current.htmlLink);
        current.links_ready = false;
        current.links_in_chat = false;
        current.agent_speak =
          'You are booked, but Meet/calendar EVENT links are NOT confirmed in the chat yet. Say you are still placing them — do NOT claim they were already shared, and do NOT share the public calendar.app.google booking page.';
        lastBookingResult = current;
        return current;
      }

      function projectsInText(text) {
        const lower = String(text || '').toLowerCase();
        return PROJECT_LINKS.filter(
          (p) =>
            p.keys.some((re) => re.test(text)) ||
            lower.includes(p.url.replace(/^https?:\/\//i, '').toLowerCase()),
        );
      }

      function isBookingShareText(text) {
        return /google meet|calendar (?:event )?links?|you're booked|you are booked|booking (?:is )?confirm|shared .{0,40}booking links?/i.test(
          text,
        );
      }

      function isPublicBookingPageOffer(text) {
        return /calendar booking link|book a call through the calendar|public booking (?:page|link)|calendar\.app\.google/i.test(
          text,
        );
      }

      function isCaseStudyOffer(text) {
        return /case study/i.test(text) && /shared|link|chat/i.test(text);
      }

      function isPortfolioOffer(text) {
        return (
          /portfolio (?:link|website|site)|shared .{0,40}portfolio/i.test(text) ||
          /projects? page|all projects|dilhara'?s projects/i.test(text)
        );
      }

      function isLinkOffer(text) {
        // Generic "shared … links in the chat" alone is NOT enough — booking confirmations use that too.
        return (
          isCaseStudyOffer(text) ||
          isPortfolioOffer(text) ||
          /shared.{0,80}(?:case study|portfolio|projects?)(?: link)?(?: in the chat)?/i.test(text)
        );
      }

      function maybeShareContextualLinks(role, content) {
        const text = String(content || '');
        if (!text.trim()) return;

        const roleLc = String(role || '').toLowerCase();
        // Deepgram may send role "assistant"; chat UI treats any non-user as agent.
        const isAgent = roleLc !== 'user';

        const mentioned = projectsInText(text);
        if (mentioned.length === 1) lastMentionedProjectUrl = mentioned[0].url;

        if (!isAgent) return;

        const forceReshare = /again|once more|re-?send|check again|still (?:don'?t|do not) see/i.test(
          text,
        );

        if (lastBookingResult?.ok) {
          if (
            isBookingShareText(text) ||
            /shared .{0,60}(?:booking|meet|calendar)|booking links?/i.test(text) ||
            forceReshare
          ) {
            void ensureBookingLinksInChat(lastBookingResult);
          }
          return;
        }

        // Booking Meet/calendar cards are injected from the API result — never piggyback a case study.
        if (isBookingShareText(text)) return;

        const linkOffer = isLinkOffer(text);

        let toShare = [];
        if (mentioned.length === 1 && (isCaseStudyOffer(text) || /case study/i.test(text))) {
          toShare = mentioned;
        } else if (isCaseStudyOffer(text) && lastMentionedProjectUrl) {
          // "I've shared the case study link" after earlier project talk — no name in this bubble.
          toShare = PROJECT_LINKS.filter((p) => p.url === lastMentionedProjectUrl);
        } else if (mentioned.length === 1 && isCaseStudyOffer(text)) {
          toShare = mentioned;
        }

        for (const project of toShare) {
          const links = [{ label: project.label, url: project.url }];
          if (project.live) links.push(project.live);
          addLinksCard({
            key: project.url,
            title: 'Case study',
            links,
            force: forceReshare || isCaseStudyOffer(text),
          });
        }

        if (toShare.length === 0 && linkOffer) {
          const wantsWork =
            /projects? page|all projects|dilhara'?s projects|\/work\b/i.test(text) ||
            (/shared .{0,50}projects?/i.test(text) && !/portfolio|case study/i.test(text));
          const wantsPortfolio = /portfolio (?:link|website|site)|shared .{0,40}portfolio/i.test(
            text,
          );

          if (wantsWork) {
            addLinksCard({
              key: 'portfolio-work',
              title: 'Projects',
              links: [{ label: 'All projects', url: PORTFOLIO_WORK_URL }],
              force: forceReshare || linkOffer,
            });
          } else if (wantsPortfolio) {
            addLinksCard({
              key: 'portfolio',
              title: 'Portfolio',
              links: [{ label: 'Website', url: PORTFOLIO_URL }],
              force: forceReshare || linkOffer,
            });
          } else if (mentioned.length > 1 && isPortfolioOffer(text)) {
            addLinksCard({
              key: 'portfolio-work',
              title: 'Projects',
              links: [{ label: 'All projects', url: PORTFOLIO_WORK_URL }],
              force: forceReshare || linkOffer,
            });
          }
        }

        if (isPublicBookingPageOffer(text)) {
          addFallbackBookingCard(forceReshare || linkOffer);
        }
      }

      /** Keep URLs/domains out of spoken transcript bubbles */
      function scrubSpokenUrls(text) {
        return String(text)
          .replace(/https?:\/\/meet\.google\.com\/[^\s]+/gi, '')
          .replace(/https?:\/\/(?:www\.)?google\.com\/calendar\/[^\s]+/gi, '')
          .replace(/https?:\/\/calendar\.app\.google\/[^\s]+/gi, '')
          .replace(/https?:\/\/dilhara\.deviitor\.com(?:\/[\w/-]*)?/gi, '')
          .replace(/\bdilhara\.deviitor\.com(?:\/[\w/-]*)?/gi, '')
          .replace(/\b(?:www\.)?wrestlingworld\.co\b/gi, '')
          .replace(/\b(?:www\.)?bettermoveco\.com\b/gi, '')
          .replace(/\bat\s+(?:dilhara\.deviitor\.com|wrestlingworld\.co|bettermoveco\.com)\b/gi, '')
          .replace(/\b(using this link|here's the link|here is the link)\s*:?\s*/gi, '')
          .replace(/\s{2,}/g, ' ')
          .replace(/\s+([.,!?])/g, '$1')
          .trim();
      }

      function extractSummaryFields(text) {
        const src = String(text).replace(/\s+/g, ' ').trim();
        const labelRe =
          /\b(Date and time|Date|Time|Timezone|Name|Email|Purpose(?: of the call)?)\s*:\s*/gi;
        const matches = [...src.matchAll(labelRe)];
        if (matches.length < 2) return {};

        const fields = {};
        const keyMap = {
          date: 'when',
          time: 'when',
          'date and time': 'when',
          timezone: 'timezone',
          name: 'name',
          email: 'email',
          purpose: 'purpose',
          'purpose of the call': 'purpose',
        };

        for (let i = 0; i < matches.length; i++) {
          const label = matches[i][1].toLowerCase();
          const key = keyMap[label];
          if (!key || fields[key]) continue;
          const valueStart = matches[i].index + matches[i][0].length;
          const valueEnd = i + 1 < matches.length ? matches[i + 1].index : src.length;
          let value = src.slice(valueStart, valueEnd).trim();

          // Drop trailing confirmation / follow-up questions from the last field.
          value = value
            .replace(
              /\s*(Does everything look good[\s\S]*|Would you like to change[\s\S]*|Please confirm[\s\S]*|What is the purpose[\s\S]*)$/i,
              '',
            )
            .replace(/^[-–—,:.\s]+|[-–—,:.\s]+$/g, '')
            .trim();

          if (value) fields[key] = value;
        }

        // Email field sometimes absorbs the next spoken question.
        if (fields.email) {
          fields.email = normalizeEmailFieldValue(
            fields.email
              .replace(/\s*(What is the purpose[\s\S]*|Does everything look good[\s\S]*)$/i, '')
              .trim(),
          );
        }

        // Purpose must be a real answer, not the agent still asking for it.
        if (
          fields.purpose &&
          /^(what is the purpose|purpose of the call\??|please (tell|share)|can (i|you) (get|have))/i.test(
            fields.purpose,
          )
        ) {
          delete fields.purpose;
        }

        const footerMatch = src.match(
          /(Does everything look good[\s\S]*|Would you like to change[\s\S]*|Please confirm[\s\S]*)$/i,
        );
        if (footerMatch) fields.footer = footerMatch[1].trim();

        return fields;
      }

      function formatMessageHtml(raw) {
        const normalized = normalizeBareUrls(
          normalizeSpokenTimes(normalizeSpokenEmail(raw)),
        )
          .replace(/\s+/g, ' ')
          .trim();
        const fields = extractSummaryFields(normalized);
        const summaryCue =
          /booking summary|summary for your booking|here'?s the summary|does everything look good/i.test(
            normalized,
          );
        // Show the card when the booking fields are present. Do not require '@' —
        // TTS often spells emails without it; we still display the best normalized value.
        const looksLikeSummary = Boolean(
          fields.when &&
            fields.name &&
            fields.email &&
            fields.purpose &&
            (fields.timezone || summaryCue),
        );

        if (looksLikeSummary) {
          const rows = [
            ['When', fields.when],
            ['Timezone', fields.timezone],
            ['Name', fields.name],
            ['Email', fields.email],
            ['Purpose', fields.purpose],
          ].filter(([, v]) => v);

          const footer =
            fields.footer || 'Does everything look good, or would you like to change anything?';

          const grid = rows
            .map(
              ([label, value]) =>
                `<div><dt>${escapeHtml(label)}</dt><dd>${linkifyHtml(escapeHtml(value))}</dd></div>`,
            )
            .join('');

          return {
            summary: true,
            html:
              `<div class="summary-title">Booking summary</div>` +
              `<dl class="summary-grid">${grid}</dl>` +
              `<div class="summary-footer">${linkifyHtml(escapeHtml(footer))}</div>`,
          };
        }

        return { summary: false, html: linkifyHtml(escapeHtml(normalized)) };
      }

      function addBubble(role, content) {
        if (!content?.trim()) return;
        const empty = document.getElementById('chatEmpty');
        if (empty) empty.remove();

        const isUser = String(role).toLowerCase() === 'user';

        if (
          isUser &&
          lastBookingResult?.ok &&
          /(?:press|show|share|send|where|need|open|check).{0,40}link|google meet|calendar event|booking links?/i.test(
            content,
          )
        ) {
          void ensureBookingLinksInChat(lastBookingResult);
        }

        const displayText = isUser ? content : scrubSpokenUrls(content);
        maybeShareContextualLinks(role, content);

        // If an agent message was only a raw URL, skip the empty spoken bubble.
        if (!isUser && !displayText) return;

        const el = document.createElement('div');
        const formatted = formatMessageHtml(displayText);
        el.className = `bubble ${isUser ? 'user' : 'agent'}${formatted.summary ? ' summary' : ''}`;
        el.innerHTML = `<span class="who">${isUser ? 'You' : 'Agent'}</span>${formatted.html}`;
        chatEl.appendChild(el);
        chatEl.scrollTop = chatEl.scrollHeight;
      }

      function clearChat() {
        shownLinkKeys.clear();
        lastMentionedProjectUrl = null;
        lastBookingResult = null;
        chatEl.innerHTML =
          '<div class="bubble empty-hint" id="chatEmpty">Transcripts appear here once you start talking.</div>';
      }

      async function createSession() {
        const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const res = await fetch('/api/session', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ source: 'direct', clientTimezone }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || data.error || `Session failed (${res.status})`);
        log(`Browser timezone: ${clientTimezone}`);
        return data;
      }

      async function mintToken() {
        const res = await fetch('/api/token', {
          method: 'POST',
          headers: {
            Authorization: sessionMeta.sessionAuth,
            'X-Session-Id': sessionMeta.sessionId,
          },
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || data.error || 'Token mint failed');
        return data.token;
      }

      async function endSession(booked = false) {
        if (!sessionMeta) return;
        try {
          await fetch('/api/session/end', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: sessionMeta.sessionAuth,
              'X-Session-Id': sessionMeta.sessionId,
            },
            body: JSON.stringify({ sessionId: sessionMeta.sessionId, booked }),
          });
        } catch {}
      }

      async function handleFunctionCall(msg) {
        log(`FunctionCallRequest: ${JSON.stringify(msg).slice(0, 400)}`);
        for (const item of msg.functions || []) {
          if (item.client_side === false) {
            log(`Skipping server-side function ${item.name}`);
            client.endFunctionCall();
            continue;
          }
          let args = {};
          try {
            args =
              typeof item.arguments === 'string'
                ? JSON.parse(item.arguments || '{}')
                : item.arguments || {};
          } catch {
            args = {};
          }
          log(`Function: ${item.name} args=${JSON.stringify(args)}`);

          if (item.name === 'end_call') {
            const result = { ok: true, ended: true, reason: args.reason || 'end_call' };
            client.sendFunctionCallResponse(
              item.id,
              item.name,
              JSON.stringify(result),
              item.thought_signature,
            );
            log(`Result: end_call → ${JSON.stringify(result)}`);
            setStatus('Ending call after confirmation…');
            client.endCallAfterConfirmation({
              reason: result.reason,
              onDone: async () => {
                await stopConversation('Call ended — tap the mic to talk again.');
                await endSession(false);
              },
            });
            continue;
          }

          try {
            setStatus(
              item.name === 'get_available_slots'
                ? 'Checking availability…'
                : item.name === 'create_booking'
                  ? 'Creating booking…'
                  : 'Working…',
            );
            let result = await client.runFunctionWithWatchdog(
              item.name,
              async () => {
                const raw = await callFunctionApi(item.name, args);
                if (item.name === 'create_booking' && raw?.ok) {
                  return ensureBookingLinksInChat(raw);
                }
                return raw;
              },
              { timeoutMs: item.name === 'create_booking' ? 35_000 : 12_000 },
            );
            log(`Result: ${item.name} → ${JSON.stringify(result).slice(0, 300)}`);

            if (item.name === 'create_booking' && result?.ok) {
              log(
                `Booking links loopback → ready=${result.links_ready} in_chat=${result.links_in_chat} meet=${Boolean(result.meetLink)} cal=${Boolean(result.htmlLink)}`,
              );
            }

            client.sendFunctionCallResponse(
              item.id,
              item.name,
              JSON.stringify(result),
              item.thought_signature,
            );
            setStatus('Listening…');

            if (
              item.name === 'get_available_slots' &&
              result &&
              result.ok === false &&
              /calendar\.app\.google|fallback/i.test(String(result.message || ''))
            ) {
              addFallbackBookingCard(false);
            }
            if (item.name === 'create_booking' && result && result.ok === false) {
              addFallbackBookingCard(false);
            }
          } catch (err) {
            log(`Function error: ${err.message}`);
            client.sendFunctionCallResponse(
              item.id,
              item.name,
              JSON.stringify({ ok: false, reason: 'api_error', message: err.message }),
            );
            setStatus('Listening…');
          }
        }
      }

      async function stopConversation(statusText) {
        if (expiryTimer) {
          clearTimeout(expiryTimer);
          expiryTimer = null;
        }
        client?.disconnect();
        client = null;
        micBtn.disabled = false;
        setConnectedUi(false);
        setStatus(statusText || 'Stopped — tap the mic to talk again.');
      }

      async function startConversation() {
        micBtn.disabled = true;
        hideMicPermissionModal();
        setStatus('Checking microphone…');
        log('Requesting microphone permission');

        let micStream = null;
        try {
          micStream = await DeviitorVoiceClient.ensureMicrophoneAccess();
        } catch (err) {
          micBtn.disabled = false;
          const message = err?.message || 'Microphone permission is required.';
          setStatus(message);
          log(`Microphone blocked: ${message}`);
          showMicPermissionModal(message);
          return;
        }

        try {
          setStatus('Creating session…');
          clearChat();
          logEl.textContent = '';
          sessionMeta = await createSession();
          log(`Session ${sessionMeta.sessionId}`);

          const ms = Date.parse(sessionMeta.expiresAt) - Date.now();
          expiryTimer = setTimeout(async () => {
            log('Session TTL reached');
            setStatus('Session ended (5 minute limit).');
            await stopConversation();
            await endSession(false);
          }, Math.max(ms, 0));

          client = new DeviitorVoiceClient({
            tokenFactory: mintToken,
            agent: sessionMeta.agent,
            audio: sessionMeta.audio,
            inactivity: { warnMs: 90_000, endMs: 45_000 },
            onEvent: (ev) => {
              if (ev.type === 'connected') {
                setStatus('Connected — applying settings…');
                log('WebSocket connected');
              } else if (ev.type === 'settings-applied') {
                setStatus('Listening — speak naturally.');
                log('Settings applied');
              } else if (ev.type === 'conversation-text') {
                addBubble(ev.role, ev.content);
                log(`${ev.role}: ${ev.content}`);
              } else if (ev.type === 'function-call-request') {
                log('FunctionCallRequest received');
                handleFunctionCall(ev).catch((err) => log(`Function failed: ${err.message}`));
              } else if (ev.type === 'agent-thinking') {
                log('Agent thinking…');
              } else if (ev.type === 'inactivity-warning') {
                setStatus('Still there? Checking in…');
                log('Inactivity warning — agent check-in');
              } else if (ev.type === 'inactivity-cleared') {
                setStatus('Listening…');
                log('Inactivity cleared — user returned');
              } else if (ev.type === 'inactivity-ending') {
                setStatus('No reply — ending call…');
                log('Inactivity end — goodbye then disconnect');
              } else if (ev.type === 'farewell-detected') {
                log(`Farewell detected (${ev.role}): ${ev.content}`);
                setStatus(ev.role === 'user' ? 'Wrapping up after goodbye…' : 'Agent said goodbye — ending…');
              } else if (ev.type === 'mute-changed') {
                setMuteUi(Boolean(ev.muted));
                setStatus(ev.muted ? 'Muted — agent can still speak' : 'Listening…');
                log(ev.muted ? 'Mic muted' : 'Mic unmuted');
              } else if (ev.type === 'call-ending') {
                setStatus('Wrapping up…');
                log(`Call ending (${ev.reason || 'unknown'})`);
              } else if (ev.type === 'call-ended') {
                log(`Call ended (${ev.reason || 'unknown'} / ${ev.trigger || ''})`);
                endSession(false);
                micBtn.disabled = false;
                setConnectedUi(false);
                setStatus('Call ended — tap the mic to talk again.');
                client = null;
              } else if (ev.type === 'disconnected') {
                setStatus(`Disconnected: ${ev.reason || 'unknown'}`);
                log(`Disconnected: ${ev.reason || 'unknown'}`);
                micBtn.disabled = false;
                setConnectedUi(false);
                client = null;
              } else if (ev.type === 'error') {
                log(`Error: ${ev.description || ev.message || JSON.stringify(ev)}`);
              } else if (ev.type === 'warning') {
                log(`Warning: ${ev.description || JSON.stringify(ev)}`);
              }
            },
          });

          setStatus('Connecting…');
          await client.connect();
          await client.startMicrophone(micStream);
          micStream = null; // ownership transferred to client
          micBtn.disabled = false;
          setConnectedUi(true);
          setStatus('Listening…');
          log('Microphone started');
        } catch (err) {
          releaseMicStream(micStream);
          throw err;
        }
      }

      micBtn.addEventListener('click', () => {
        if (connectedUi) return;
        startConversation().catch((err) => {
          micBtn.disabled = false;
          setConnectedUi(false);
          setStatus(err.message || 'Failed to start');
          log(err.message || String(err));
        });
      });

      micModalRetry.addEventListener('click', () => {
        hideMicPermissionModal();
        if (connectedUi) return;
        startConversation().catch((err) => {
          micBtn.disabled = false;
          setConnectedUi(false);
          setStatus(err.message || 'Failed to start');
          log(err.message || String(err));
        });
      });

      micModalDismiss.addEventListener('click', () => hideMicPermissionModal());
      micModal.addEventListener('click', (ev) => {
        if (ev.target === micModal) hideMicPermissionModal();
      });

      stopBtn.addEventListener('click', async () => {
        await stopConversation();
        await endSession(false);
      });

      muteBtn.addEventListener('click', () => {
        if (!client || !connectedUi) return;
        client.toggleMute();
      });

      function toggleDebug(force) {
        const open = typeof force === 'boolean' ? force : !debugPanel.classList.contains('visible');
        debugPanel.classList.toggle('visible', open);
        debugFab.classList.toggle('open', open);
      }

      debugFab.addEventListener('click', () => toggleDebug());
      debugClose.addEventListener('click', () => toggleDebug(false));


document.getElementById('buildVersion').textContent = `v${BUILD_VERSION}`;
log(`Client v${BUILD_VERSION}`);

      window.addEventListener('beforeunload', () => endSession(false));
